/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseOnDemandProgressionType } from "../types/ECourseOnDemandProgressionType.ts";

/**
 * @description 1 = None | 2 = Ordered | 3 = ClassDuration | 4 = Limited | 5 = Grade |
 */
export const eCourseOnDemandProgressionTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = None | 2 = Ordered | 3 = ClassDuration | 4 = Limited | 5 = Grade | ",
  ) as unknown as ToZod<ECourseOnDemandProgressionType>;
